/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  faAddressCard,
  faCalendarAlt,
  faCheckCircle,
  faListAlt,
  faCalendarCheck,
  faSquare,
  faUser,
  faUsers
} from '@fortawesome/free-regular-svg-icons';
import { faMoneyCheckAlt } from '@fortawesome/free-solid-svg-icons';
import {
  UilChartPie,
  UilUsersAlt,
  UilBill,
  UilUserCircle,
  UilCube,
  UilUserMd,
  UilUserLocation,
  UilFileCheck,
  UilClipboardAlt,
  UilMap,
  UilMapMarker,
  UilDirections
} from '@iconscout/react-unicons';
import {
  approvalPaths,
  dashboardPaths,
  hrmsPaths,
  masterPaths,
  operationPaths,
  paymentPaths,
  checkPaths,
  inventoryPath
} from 'constants/pagePath';
import fetchData from 'services/fetchData';
// import default_modules from 'context/modules_list';

const generateSuperAdminMap = async () => {
  // const count = await fetchData('get_count_checker');
  const count = { status: false };
  let response;
  if (count.status) {
    response = count.data;
  } else {
    response = { driver: 0, truck: 0 };
  }
  return [
    {
      label: 'Dashboard',
      icon: UilChartPie,
      horizontalNavLabel: 'home',
      active: true,
      labelDisabled: true,
      pages: [
        {
          name: 'Home',
          moduleName: 'general_dashboard',
          icon: 'home',
          flat: true,
          path: '/',
          pathName: 'Admin Dashboard',
          active: true
        },
        {
          name: 'Dashboard',
          icon: 'pie-chart',
          active: true,
          flat: true,
          pages: [
            {
              name: 'Payments',
              moduleName: 'Payment Dashboard',
              actionName: ['view'],
              path: dashboardPaths.admin_dashboard,
              pathName: 'Admin Dashboard',
              active: true
            },
            {
              name: 'HRMS',
              moduleName: 'HRMS Dashboard',
              actionName: ['view'],
              path: dashboardPaths.hrms_dashboard,
              pathName: 'HRMS Dashboard',
              active: true
            },
            {
              name: 'My Attendance',
              moduleName: 'My Dashboard',
              actionName: ['view'],
              // icon: 'home',
              flat: true,
              path: '/dashboard/my-attendance',
              pathName: 'My Attendance',
              active: true
            },
            // {
            //   name: 'Inventory',
            //   moduleName: 'All',
            //   actionName: ['view'],
            //   path: inventoryPath.Dashboard.list,
            //   pathName: 'Inventory Dashboard',
            //   active: true,
            //   flat: true
            // },
            // {
            //   name: 'Sales',
            //   moduleName: 'All',
            //   actionName: ['view'],
            //   path: '/dashboard/sales',
            //   pathName: 'Sales',
            //   active: true,
            //   flat: true
            // },
            {
              name: 'FlyAsh Report',
              moduleName: 'FlyAsh Report',
              actionName: ['view'],
              // icon: 'bar-chart',
              path: '/dashboard/flyAsh-report',
              pathName: 'FlyAsh Report',
              active: true,
              flat: true
            },
            {
              name: 'Coal/Iron Ore Report',
              moduleName: 'Coal-Iron Ore Report',
              actionName: ['view'],
              // icon: 'bar-chart',
              path: '/dashboard/coalIronore-report',
              pathName: 'CoalIronore Report',
              active: true,
              flat: true
            }
          ]
        }
      ]
    },
    {
      label: 'Payments',
      icon: UilCube,
      pages: [
        {
          name: 'Quick Payment',
          icon: 'database',
          active: true,
          flat: true,
          pages: [
            {
              name: 'Quick Payment',
              moduleName: 'Quick Payment',
              actionName: ['payer'],
              path: paymentPaths.quickPayment,
              active: true
            },
            {
              name: 'Quick Payment List',
              moduleName: 'Quick Payment',
              actionName: ['view', 'Payer'],
              path: paymentPaths.quickPaymentList,
              pathName: 'quick-payment-list',
              active: true
            }
          ]
        },
        {
          name: 'Challans',
          icon: 'credit-card',
          active: true,
          flat: true,
          pages: [
            {
              name: 'Coal/Iron Ore',
              pathName: 'Coal/Iron Ore',
              active: true,
              pages: [
                {
                  name: 'Payment Pending',
                  moduleName: 'Coal/Iron Ore',
                  actionName: ['view', 'payer'],
                  path: paymentPaths.coalIronOre.paymentPending,
                  pathName: 'Payment Pending',
                  active: true
                },
                {
                  name: 'Payment Initiated',
                  moduleName: 'Coal/Iron Ore POD',
                  actionName: ['view'],
                  path: paymentPaths.coalIronOre.paymentInitiated,
                  pathName: 'Payment Initiated',
                  active: true
                },
                {
                  name: 'Check Pod',
                  moduleName: 'Coal/Iron Ore POD',
                  actionName: ['checker'],
                  path: paymentPaths.coalIronOre.challanApproval,
                  pathName: 'Challan Approval',
                  active: true
                },
                {
                  name: 'Pod Approval',
                  moduleName: 'Coal/Iron Ore POD',
                  actionName: ['approver'],
                  path: paymentPaths.coalIronOre.podApproval,
                  pathName: 'Pod Approval',
                  active: true
                },
                {
                  name: 'Cancelled Challans',
                  moduleName: 'Cancelled Coal/Iron ore Challans',
                  actionName: ['view'],
                  path: paymentPaths.coalIronOre.canceledChallans,
                  pathName: 'Cancelled Challans',
                  active: true
                }
              ]
            },
            {
              name: 'FlyAsh',
              pathName: 'FlyAsh',
              active: true,
              pages: [
                {
                  name: 'Payment Pending',
                  moduleName: 'FlyAsh',
                  actionName: ['view', 'payer'],
                  path: paymentPaths.flyAsh.paymentPending,
                  pathName: 'Payment Pending',
                  active: true
                },
                {
                  name: 'Payment Initiated',
                  moduleName: 'FlyAsh',
                  actionName: ['view', 'payer'],
                  path: paymentPaths.flyAsh.paymentInitiated,
                  pathName: 'Payment Initiated',
                  active: true
                },
                {
                  name: 'Canceled Challans',
                  moduleName: 'Cancelled FlyAsh Challans',
                  actionName: ['view'],
                  path: paymentPaths.flyAsh.canceledChallans,
                  pathName: 'Canceled Challans',
                  active: true
                }
              ]
            }
          ]
        },
        {
          name: 'Payment History ',
          moduleName: 'Payment History',
          actionName: ['view'],
          icon: 'clock',
          path: paymentPaths.paymentHistory,
          pathName: 'Payment History',
          active: true,
          flat: true
        },
        {
          name: 'Vendor Invoices',
          icon: 'user',
          active: true,
          flat: true,
          new: true,
          pages: [
            {
              name: 'Create Invoices',
              moduleName: 'Vendor Invoices',
              actionName: ['view'],
              path: paymentPaths.vendorInvoices.createInvoices,
              active: true,
              pathName: 'Create Invoice'
            },
            {
              name: 'Check Invoices',
              moduleName: 'Vendor Invoices',
              actionName: ['checker'],
              path: paymentPaths.vendorInvoices.checkInvoices,
              pathName: 'Check Payment',
              active: true
            },
            {
              name: 'Paid Invoices',
              moduleName: 'Vendor Invoices',
              actionName: ['payer'],
              path: paymentPaths.vendorInvoices.paidInvoices,
              pathName: 'Paid Invoices',
              active: true
            },
            {
              name: 'Rejected Invoices',
              moduleName: 'Rejected Invoices',
              actionName: ['view'],
              path: paymentPaths.vendorInvoices.rejectedInvoices,
              pathName: 'Rejected Invoices',
              active: true
            }
          ]
        },
        // {
        //   name: 'Trucker Payments',
        //   moduleName: 'trucker_payments',
        //   icon: 'clock',
        //   path: paymentPaths.truckerPayment.truckerPayments,

        //   pathName: 'Trucker Payments',
        //   active: true,
        //   flat: true,
        //   new: true
        // },
        {
          name: 'Trucker Payments',
          icon: 'user',
          active: true,
          flat: true,
          // new: true,
          pages: [
            {
              name: 'Pending List',
              moduleName: 'Trucker Payments',
              actionName: ['view'],
              path: paymentPaths.truckerPayments.pendingList,
              active: true,
              pathName: 'Pending List'
            },
            {
              name: 'Checking List',
              moduleName: 'Trucker Payments',
              actionName: ['checker'],
              path: paymentPaths.truckerPayments.checkingList,
              pathName: 'Checking List',
              active: true
            },
            {
              name: 'Approval list',
              moduleName: 'Trucker Payments',
              actionName: ['approver'],
              path: paymentPaths.truckerPayments.approvalList,
              pathName: 'Approval list',
              active: true
            },
            {
              name: 'Payment List',
              moduleName: 'Trucker Payments',
              actionName: ['payer'],
              path: paymentPaths.truckerPayments.paymentList,
              pathName: 'Payment List',
              active: true
            }
          ]
        }
      ]
    },
    {
      label: 'Masters',
      icon: UilCube,
      pages: [
        {
          name: 'Vendors',
          icon: 'user',
          active: true,
          flat: true,
          pages: [
            {
              name: 'Regular',
              moduleName: 'Regular Vendor',
              actionName: ['view'],
              path: masterPaths.vendor.regular.list,
              pathName: 'Regular',
              active: true
            },
            {
              name: 'Trucker',
              moduleName: 'Trucker Vendor',
              actionName: ['view'],
              path: masterPaths.vendor.trucker.list,
              pathName: 'Trucker',
              active: true
            },
            {
              name: 'Fuel Retailer',
              moduleName: 'Fuel Retailer',
              actionName: ['view'],
              path: masterPaths.vendor.fuelRetailer.list,
              pathName: 'Retailer',
              active: true
            }
          ]
        },
        {
          name: 'Vehicles',
          moduleName: 'Vehicle',
          actionName: ['view'],
          icon: 'truck',
          path: masterPaths.vehicle.list,
          pathName: 'Vehicles',
          active: true,
          flat: true
        },
        {
          name: 'Location',
          iconSet: 'unicons',
          icon: <UilUserLocation size={16} />,
          active: true,
          flat: true,
          pages: [
            {
              name: 'Branch',
              moduleName: 'Branch',
              actionName: ['view'],
              path: masterPaths.location.branch,
              pathName: 'Branch',
              active: true
            },
            {
              name: 'Location',
              moduleName: 'Location',
              actionName: ['view'],
              path: masterPaths.location.location,
              pathName: 'Location',
              active: true
            },
            {
              name: 'Route',
              moduleName: 'Route',
              actionName: ['view'],
              path: masterPaths.location.route,
              pathName: 'Route',
              active: true
            }
          ]
        },
        {
          name: 'Customers',
          moduleName: 'Customers',
          actionName: ['view'],
          icon: 'user',
          path: masterPaths.customer.list,
          pathName: 'Customers',
          active: true,
          flat: true
        }
      ]
    },
    {
      label: 'HRMS',
      icon: UilCube,
      pages: [
        {
          name: 'Employee',
          moduleName: 'Employee',
          actionName: ['view'],
          iconSet: 'font-awesome',
          icon: faAddressCard,
          path: hrmsPaths.employee.list,
          pathName: 'Employee List',
          active: true,
          flat: true
        },
        {
          name: 'Separated Employee',
          actionName: ['view'],
          moduleName: 'Separated Employee',
          iconSet: 'font-awesome',
          icon: faAddressCard,
          path: hrmsPaths.separated_employee.list,
          pathName: 'Separated Employee List',
          active: true,
          flat: true
        },
        {
          name: 'HR Report',
          moduleName: 'All',
          actionName: ['view'],
          iconSet: 'font-awesome',
          icon: faAddressCard,
          path: hrmsPaths.hr_report,
          pathName: 'HR Report',
          active: true,
          flat: true
        },
        {
          name: 'Driver',
          moduleName: 'Driver',
          actionName: ['view'],
          iconSet: 'unicons',
          icon: <UilUserMd size={16} />,
          path: hrmsPaths.driver.list,
          pathName: 'Driver List',
          active: true,
          flat: true
        },
        {
          name: 'Leave',
          moduleName: 'Leave',
          actionName: ['view'],
          iconSet: 'font-awesome',
          icon: faCalendarAlt,
          path: hrmsPaths.leave,
          pathName: 'Leave List',
          active: true,
          flat: true
        },
        {
          name: 'Manual Punch',
          moduleName: 'Manual Punch',
          actionName: ['view'],
          iconSet: 'unicons',
          icon: <UilFileCheck size={16} />,
          path: hrmsPaths.manualPunch,
          pathName: 'Manual Punch',
          active: true,
          flat: true
        },
        // {
        //   name: 'Attendance',
        //   moduleName: 'attendance',
        //   iconSet: 'font-awesome',
        //   icon: faCheckCircle,
        //   path: hrmsPaths.attendance.today_list,
        //   pathName: 'Attendance List',
        //   active: true,
        //   flat: true
        // },
        {
          name: 'Attendance',
          iconSet: 'font-awesome',
          icon: faCheckCircle,
          active: true,
          flat: true,
          pages: [
            {
              name: 'Driver',
              moduleName: 'Driver Attendance',
              actionName: ['view'],
              path: hrmsPaths.attendance.driver.today_list,
              pathName: 'Driver Attendance List',
              active: true
            },
            {
              name: 'Employee',
              moduleName: 'Employee Attendance',
              actionName: ['view'],
              path: hrmsPaths.attendance.employee.today_list,
              pathName: 'Employee Attendance List',
              active: true
            }
          ]
        },
        {
          name: 'Payrolls',
          iconSet: 'font-awesome',
          icon: faMoneyCheckAlt,
          active: true,
          flat: true,
          pages: [
            {
              name: 'Payroll Driver',
              pathName: 'Payroll Driver',
              active: false,
              pages: [
                {
                  name: 'Create Payroll',
                  moduleName: 'Driver Payrolls',
                  actionName: ['view'],
                  path: hrmsPaths.payroll.driver.payroll_run,
                  pathName: 'Create Payroll',
                  active: false
                  // new: true
                },
                {
                  name: 'Check Payroll',
                  moduleName: 'Driver Payrolls',
                  actionName: ['checker'],
                  path: hrmsPaths.payroll.driver.check_payroll,
                  pathName: 'Check Payroll',
                  active: false
                },
                {
                  name: 'Pay Payroll',
                  moduleName: 'Driver Payrolls',
                  actionName: ['payer'],
                  path: hrmsPaths.payroll.driver.pay_payroll,
                  pathName: 'Pay Payroll',
                  active: false
                }
              ]
            },
            {
              name: 'Payroll Employee',
              pathName: 'Payroll Employee',
              active: true,
              pages: [
                {
                  name: 'Create Payroll',
                  moduleName: 'Employee Payrolls',
                  actionName: ['view'],
                  path: hrmsPaths.payroll.employee.create_payroll,
                  pathName: 'Create Payroll',
                  active: true
                  // new: true
                }
                // {
                //   name: 'Check Payroll',
                //   moduleName: 'Employee Payrolls',
                //   actionName: ['checker'],
                //   path: hrmsPaths.payroll.employee.check_payroll,
                //   pathName: 'Check Payroll',
                //   active: true
                // },
                // {
                //   name: 'Pay Payroll',
                //   moduleName: 'Employee Payrolls',
                //   actionName: ['payer'],
                //   path: hrmsPaths.payroll.employee.pay_payroll,
                //   pathName: 'Pay Payroll',
                //   active: true
                // }
              ]
            }
          ]
        }
        // {
        //   name: 'Payrolls',
        //   iconSet: 'font-awesome',
        //   icon: faMoneyCheckAlt,
        //   active: true,
        //   flat: true,
        //   // hasNew: 'true',
        //   pages: [
        //     {
        //       name: 'Driver',
        //       moduleName: 'driver_payroll',
        //       path: hrmsPaths.payroll.driver.payroll_run,
        //       pathName: 'Driver Payrolls List',
        //       active: true
        //       // new: true
        //     },
        //     {
        //       name: 'Employee',
        //       moduleName: 'employee_payroll',
        //       path: hrmsPaths.payroll.employee.payroll_run,
        //       pathName: 'Employee Payrolls List',
        //       active: true
        //       // new: true
        //     }
        //   ]
        // }
      ]
    },
    {
      label: 'OPERATIONS',
      icon: UilCube,
      pages: [
        {
          name: 'PO',
          moduleName: 'PO',
          actionName: ['view'],
          iconSet: 'unicons',
          icon: <UilBill size={16} />,
          path: operationPaths.PO.list,
          pathName: 'PO List',
          active: true,
          flat: true
        },
        {
          name: 'DO',
          moduleName: 'DO',
          actionName: ['view'],
          iconSet: 'unicons',
          icon: <UilFileCheck size={16} />,
          path: operationPaths.DO.list,
          pathName: 'DO List',
          active: true,
          flat: true
        },
        {
          name: 'Permit',
          moduleName: 'Permit',
          actionName: ['view'],
          iconSet: 'unicons',
          icon: <UilClipboardAlt size={16} />,
          path: operationPaths.permit.list,
          pathName: 'Permit List',
          active: true,
          flat: true
        },
        // {
        //   name: 'Challan',
        //   iconSet: 'font-awesome',
        //   icon: faListAlt,
        //   path: operationPaths.challan.list,
        //   pathName: 'Challan List',
        //   active: true,
        //   flat: true
        // },
        {
          name: 'Trips ',
          icon: 'map',
          active: true,
          flat: true,
          pages: [
            {
              name: 'Running Trips ',
              moduleName: 'Running Trips',
              actionName: ['view'],
              path: operationPaths.trips.running_trip,
              pathName: 'Running Trips',
              active: true
            },
            {
              name: 'Breakdown Trips ',
              moduleName: 'Breakdown Trips',
              actionName: ['view'],
              path: operationPaths.trips.breakdown_trip,
              pathName: 'Breakdown Trips',
              active: true
            },
            {
              name: 'Completed Trips ',
              moduleName: 'Completed Trips',
              actionName: ['view'],
              path: operationPaths.trips.completed_trip,
              pathName: 'Completed Trips',
              active: true
            }
          ]
        }
      ]
    },

    // {
    //   label: 'Inventory',
    //   icon: UilCube,
    //   pages: [
    //     {
    //       name: 'Inventory',
    //       moduleName: 'All',
    //       actionName: ['view'],
    //       iconSet: 'unicons',
    //       icon: <UilClipboardAlt size={16} />,
    //       path: inventoryPath.InventoryItems.list,
    //       pathName: 'Inventory Items',
    //       active: true,
    //       flat: true
    //     },
    //     {
    //       name: 'Categories',
    //       moduleName: 'All',
    //       actionName: ['view'],
    //       iconSet: 'unicons',
    //       icon: <UilUserCircle size={16} />,
    //       path: inventoryPath.InventoryCategories.list,
    //       pathName: 'Inventory Categories',
    //       active: true,
    //       flat: true
    //     },
    //     {
    //       name: 'Reports',
    //       moduleName: 'All',
    //       actionName: ['view'],
    //       iconSet: 'unicons',
    //       icon: <UilBill size={16} />,
    //       path: inventoryPath.InventoryReports.list,
    //       pathName: 'Inventory Reports',
    //       active: true,
    //       flat: true
    //     }
    //   ]
    // },

    {
      label: 'Check',
      icon: UilCube,
      pages: [
        {
          name: 'Manual Punch Check',
          iconSet: 'unicons',
          icon: <UilFileCheck size={16} />,
          moduleName: 'Manual Punch',
          actionName: 'checker',
          active: true,
          flat: true,
          path: checkPaths.ManualPunch.pending,
          pathName: 'Manual Punch Check'
        }
      ]
    },

    {
      label: 'Approvals',
      icon: UilCube,
      pages: [
        {
          name: 'Regular Vendor Approval',
          icon: 'user',
          moduleName: 'Regular Vendor',
          actionName: ['approver'],
          active: true,
          flat: true,
          path: approvalPaths.Regularvendor.pending,
          pathName: 'Pending Approvals'
        },
        {
          name: 'Trucker Approval',
          moduleName: 'Trucker Vendor',
          actionName: ['approver'],
          active: true,
          icon: 'truck',
          flat: true,
          path: approvalPaths.Trucker.pending,
          pathName: 'Pending Approvals'
        },
        {
          name: 'Fuel Retailer Approval',
          moduleName: 'Fuel Retailer',
          actionName: ['approver'],
          icon: 'user',
          active: true,
          flat: true,
          path: approvalPaths.FuelRetailer.pending,
          pathName: 'Pending Approvals'
        },
        {
          name: 'Vehicle Approval',
          icon: 'truck',
          moduleName: 'Vehicle',
          actionName: ['approver'],
          active: true,
          flat: true,
          path: approvalPaths.vehicle.pending,
          pathName: 'Pending Approvals'
        },
        {
          name: 'Branch Approval',
          moduleName: 'Branch',
          actionName: ['approver'],
          iconSet: 'unicons',
          icon: <UilMap size={16} />,
          active: true,
          flat: true,
          path: approvalPaths.branch.pending,
          pathName: 'Pending Approvals'
        },
        {
          name: 'Location Approval',
          moduleName: 'Location',
          actionName: ['approver'],
          iconSet: 'unicons',
          icon: <UilMapMarker size={16} />,
          active: true,
          flat: true,
          path: approvalPaths.location.pending,
          pathName: 'Pending Approvals'
        },
        {
          name: 'Route Approval',
          moduleName: 'Route',
          actionName: ['approver'],
          iconSet: 'unicons',
          icon: <UilDirections size={16} />,
          active: true,
          flat: true,
          path: approvalPaths.route.pending,
          pathName: 'Pending Approvals'
        },
        {
          name: 'Customer Approval',
          moduleName: 'Customers',
          actionName: ['approver'],
          icon: 'user',
          active: true,
          flat: true,
          path: approvalPaths.customer.pending,
          pathName: 'Pending Approvals'
        },
        {
          name: 'Employee Approval',
          moduleName: 'Employee',
          actionName: ['approver'],
          iconSet: 'font-awesome',
          icon: faAddressCard,
          active: true,
          flat: true,
          path: approvalPaths.employee.pending,
          pathName: 'Pending Approvals'
        },
        {
          name: 'Driver Approval',
          moduleName: 'Driver',
          actionName: ['approver'],
          iconSet: 'unicons',
          icon: <UilUserMd size={16} />,
          active: true,
          flat: true,
          path: approvalPaths.driver.pending,
          pathName: 'Pending Approvals'
        },

        {
          name: 'PO Approval',
          moduleName: 'PO',
          actionName: ['approver'],
          iconSet: 'unicons',
          icon: <UilBill size={16} />,
          active: true,
          flat: true,
          path: approvalPaths.po.pending,
          pathName: 'Pending Approvals'
        },
        {
          name: 'DO Approval',
          moduleName: 'DO',
          actionName: ['approver'],
          iconSet: 'unicons',
          icon: <UilFileCheck size={16} />,
          active: true,
          flat: true,
          path: approvalPaths.do.pending,
          pathName: 'Pending Approvals'
        },
        {
          name: 'Permit Approval',
          moduleName: 'Permit',
          actionName: ['approver'],
          iconSet: 'unicons',
          icon: <UilClipboardAlt size={16} />,
          active: true,
          flat: true,
          path: approvalPaths.permit.pending,
          pathName: 'Pending Approvals'
        },

        {
          name: 'Department Approval',
          moduleName: 'Department',
          actionName: ['approver'],
          iconSet: 'unicons',
          icon: <UilUsersAlt size={16} />,
          active: true,
          flat: true,
          path: approvalPaths.department.pending,
          pathName: 'Pending Approvals'
        },
        {
          name: 'Designation Approval',
          moduleName: 'Designation',
          actionName: ['approver'],
          iconSet: 'unicons',
          icon: <UilUserCircle size={16} />,
          active: true,
          flat: true,
          path: approvalPaths.designation.pending,
          pathName: 'Pending Approvals'
        },
        {
          name: 'Shift Approval',
          moduleName: 'Shifts',
          actionName: ['approver'],
          iconSet: 'font-awesome',
          icon: faListAlt,
          active: true,
          flat: true,
          path: approvalPaths.shift.pending,
          pathName: 'Pending Approvals'
        },
        {
          name: 'Holidays Approval',
          moduleName: 'Holidays',
          actionName: ['approver'],
          iconSet: 'font-awesome',
          icon: faCalendarCheck,
          active: true,
          flat: true,
          path: approvalPaths.holidays.pending,
          pathName: 'Pending Approvals'
        },
        {
          name: 'Material Approval',
          moduleName: 'Material',
          actionName: ['approver'],
          iconSet: 'font-awesome',
          icon: faSquare,
          active: true,
          flat: true,
          path: approvalPaths.material.pending,
          pathName: 'Pending Approvals'
        },
        {
          name: 'Vehicle Type Approval',
          moduleName: 'Vehicle Type',
          actionName: ['approver'],
          // iconSet: 'font-awesome',
          icon: 'truck',
          active: true,
          flat: true,
          path: approvalPaths.vehicleType.pending,
          pathName: 'Pending Approvals'
        },
        // {
        //   name: 'Casual Break Approval',
        //   moduleName: 'Casual Break',
        //   iconSet: 'font-awesome',
        //   actionName: ['approver'],
        //   icon: faSquare,
        //   active: true,
        //   flat: true,
        //   path: approvalPaths.casualBreak.pending,
        //   pathName: 'Pending Approvals'
        // },
        // {
        //   name: 'Outer Working Approvals',
        //   moduleName: 'Outer Working',
        //   actionName: ['approver'],
        //   icon: 'truck',
        //   active: true,
        //   flat: true,
        //   path: approvalPaths.outerWorking.pending,
        //   pathName: 'Pending Approvals'
        // },
        {
          name: 'Challan Approvals',
          moduleName: 'Coal/Iron Ore',
          actionName: ['approver'],
          icon: 'credit-card',
          active: true,
          flat: true,
          path: approvalPaths.challan.pending,
          pathName: 'Pending Approvals'
        },
        {
          name: 'Manual Punch Approvals',
          moduleName: 'Manual Punch',
          actionName: ['approver'],
          iconSet: 'unicons',
          icon: <UilFileCheck size={16} />,
          active: true,
          flat: true,
          path: approvalPaths.manualPunch.pending,
          pathName: 'Pending Approvals'
        },
        {
          name: 'Employee Late Punch-in',
          moduleName: 'Late Punch-in Employee',
          actionName: ['approver'],
          iconSet: 'unicons',
          icon: <UilFileCheck size={16} />,
          active: true,
          flat: true,
          path: approvalPaths.latePunchin.pending,
          pathName: 'Pending Approvals'
        }
      ]
    }
  ];
};

export const SuperAdminSitemap = generateSuperAdminMap;
